import keypressSound from './sounds/keypress.mp3';
import jumpSound from './sounds/jump.wav';
import crashSound from './sounds/crash.wav';


let keypress = new Audio(keypressSound)
export function playKeypressSound () {
  keypress.currentTime = 0;
  keypress.volume = .5
  keypress.play()
}

let jump = new Audio(jumpSound)
export function playJumpSound () {
  jump.currentTime = 0;
  jump.play()
}

let crash = new Audio(crashSound)
export function playCrashSound () {
  crash.play()
}